// extracted by css-extract-rspack-plugin
export default {"facts":"facts-H8qB9H","fact":"fact-F6gAzk"};